import { includes } from 'lodash';

export default function statusInQueue(statusList, payloadStatus) {
  return !includes(statusList, payloadStatus);
}
